<div class="ui buttons">
  <button *ngFor="let severity of severities" class="ui basic button {{ severity.name.toLowerCase() }}" type="button"
          [class.active]="isSelected(severity)"
          (click)="onClick(severity)">
    {{ severity.name }}
  </button>
</div>
